import { Controller } from "@hotwired/stimulus"
import { showInfo } from "../lib/platform_toast"

/**
 * Disabled CTA Controller
 *
 * Shows a toast message when a disabled CTA card is clicked.
 * Used for "coming soon" features that are not yet available.
 */
export default class extends Controller {
  static values = {
    message: String
  }

  showMessage(event) {
    event.preventDefault()
    showInfo(this.messageValue)
  }
}
